import * as yup from "yup";

export type IFormData = {
  email: string;
  name: string;
  password: string;
};

export type ICompleteFormData = {
  name: string;
  password: string;
  confirmPassword: string;
};

export type IEmailValidation = {
  email: string;
};

export type ICodeForEmail = {
  code: string;
};

export const defaultValuesValidateCode: ICodeForEmail = {
  code: "",
};

export const formSchema = yup.object({
  name: yup.string().required("*Campo obrigatório"),
  password: yup.string().required("*Campo obrigatório"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "*As senhas precisam ser iguais")
    .required("*Campo Obrigatório"),
});

export const emailValidationFormSchema = yup.object({
  email: yup.string().email("*E-mail Invalido").required("*Campo obrigatório"),
});

export const codeForEmailSchema = yup.object({
  code: yup
    .string()
    .min(8, "Tamanho mínimo: 8 caracteres")
    .max(8, "Tamanho máximo: 8 caracteres")
    .required("*Campo Obrigatório"),
});
